import { Vue, Component } from 'vue-property-decorator';
import { readUserProfile } from '@/store/main/getters';
import { IUserProfile } from '@/interfaces';

@Component
export default class PrivilegeMixin extends Vue {
  // This call checks the privileges against the user record roles
  public roleCheck(prKey: string, privRequired: string) {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    if (rec && rec.roles && rec.roles[prKey]) {
      const privUser = rec.roles[prKey];
      if (privRequired === 'Manage') {
        return privUser === 'Manage';
      } else if (privRequired === 'Write') {
        return privUser === 'Write' || privUser === 'Manage';
      } else if (privRequired === 'Read') {
        return (
          privUser === 'Read' || privUser === 'Write' || privUser === 'Manage'
        );
      }
    } else {
      return false;
    }
  }

  public isEMT() {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    return rec ? rec.userrole_id === 3 : false;
  }

  public isAdmin() {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    return rec ? rec.userrole_id === 1 : false;
  }

  // Privileges:  "NoAccess", "Read", "Write", "Manage"
  // "pr_manage", "pr_reference", "pr_device", "pr_site", "pr_intervention",
  // "pr_site_service_order", "pr_site_notification", "pr_site_files"
  // "pr_device_files", "pr_tc", "pr_tc_service_order", "pr_tc_notification",
  // "pr_tc_files"
}
